import { FC } from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { useMenuState } from '../../../../../components/DropdownMenu/MenuContext';

const Container = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
`;

export const ColumnsSettingsActionButtons: FC = () => {
  const { onCancel } = useMenuState();

  return (
    <Container>
      <Button onClick={onCancel} variant='outlined' color={'secondary'}>
        Cancel
      </Button>
    </Container>
  );
};
